const CartUtil = (function () {
	return {
		addByData: function (data) {
			var ajax = $.ajax({
				url: window.elkitorg_config.cart_add_url,
				method: 'post',
				data: data,
				dataType: 'json'
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_add', arguments);
			});

			return ajax;
		},
		addProductBySkuId: function (sku_id, quantity, services) {
			var ajax = CartUtil.addByData($.extend({
				sku_id: sku_id,
				quantity: quantity,
				html: true
			}, CartUtil.formatServices(services)));

			ajax.then(function () {
				$(document).trigger('shop_cart_add', arguments);
			});

			return ajax;
		},
		addProduct: function (product_id, sku_id, quantity, services) {
			var ajax = CartUtil.addByData($.extend({
				product_id: product_id,
				sku_id: sku_id,
				quantity: quantity,
				html: true
			}, CartUtil.formatServices(services)));

			ajax.then(function () {
				$(document).trigger('shop_cart_add', arguments);
			});

			return ajax;
		},
		addProductByFeatures: function (product_id, features, quantity, services) {
			var ajax = CartUtil.addByData($.extend({
				product_id: product_id,
				features: features,
				quantity: quantity,
				html: true
			}, CartUtil.formatServices(services)));

			ajax.then(function () {
				$(document).trigger('shop_cart_add', arguments);
			});

			return ajax;
		},
		addService: function (parent_id, service_id, service_variant_id) {
			var ajax = CartUtil.addByData({
				parent_id: parent_id,
				service_id: service_id,
				service_variant_id: service_variant_id,
				html: true
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_add_service', arguments);
			});

			return ajax;
		},
		updateItem: function (item_id, quantity) {
			var ajax = $.ajax({
				url: window.elkitorg_config.cart_save_url,
				method: 'post',
				data: {
					id: item_id,
					quantity: quantity,
					html: true
				},
				dataType: 'json'
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_update', arguments);
			});

			return ajax;
		},
		updateService: function (item_id, service_variant_id) {
			var ajax = $.ajax({
				url: window.elkitorg_config.cart_save_url,
				method: 'post',
				data: {
					id: item_id,
					service_variant_id: service_variant_id,
					html: true
				},
				dataType: 'json'
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_update', arguments);
			});

			return ajax;
		},
		deleteItem: function (item_id) {
			var ajax = $.ajax({
				url: window.elkitorg_config.cart_delete_url,
				method: 'post',
				data: {
					id: item_id,
					html: true
				},
				dataType: 'json'
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_delete', arguments);
			});

			return ajax;
		},
		clear: function () {
			var ajax = $.ajax({
				url: window.elkitorg_config.cart_url + '?clear=1',
				method: 'post',
				dataType: 'json'
			});

			ajax.then(function () {
				$(document).trigger('shop_cart_clear', arguments);
			});

			return ajax;
		},
		formatServices: function (services) {
			services = services || [];
			var data = {};

			data.services = services.map(function (service) {
				return service.id;
			});

			data.service_variants = services.reduce(function (variants, service) {
				variants[service.id] = service.variant_id;

				return variants;
			}, {});

			return data;
		}
	};
})();

export default CartUtil;
